import React from 'react';
import { createRoot } from 'react-dom/client';

import { I18nextProvider, i18n, initI18n } from '@modernloop/i18n';
import { installStaleDeployReloadHandler } from '@modernloop/shared/utils';

import * as serviceWorker from 'src/serviceWorker';

import App from './App';
import { enviromentConfig } from './config';

// This is so it's easier to see which environment you're in
const setAlternateFavicon = () => {
  try {
    let faviconName;
    if (enviromentConfig.environment === 'development') {
      faviconName = 'favicon.dev.ico';
    }
    if (enviromentConfig.environment === 'staging') {
      faviconName = 'favicon.stg.ico';
    }
    if (!faviconName) {
      return;
    }
    const faviconLink = document.querySelector("link[rel='shortcut icon']") as HTMLLinkElement;
    if (faviconLink) {
      faviconLink.href = `/${faviconName}`;
    }
  } catch (e) {
    // dont want to fail right at the top of the app
    console.error(e);
  }
};

setAlternateFavicon();

// Auto-recover when a deploy replaces hashed assets out from under a loaded tab.
installStaleDeployReloadHandler();

const renderApp = async () => {
  await initI18n();
  // Dev-only: expose the i18n instance so tooling (e.g. the en-sloth completeness audit)
  // can force a locale at runtime. Never present in production builds.
  if (import.meta.env.DEV) {
    // eslint-disable-next-line no-underscore-dangle -- conventional dev-global name for the i18n audit tool
    (window as unknown as { __i18n: typeof i18n }).__i18n = i18n;
  }

  const container = document.getElementById('root');
  if (!container) {
    throw new Error('Root container not found');
  }

  createRoot(container).render(
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  );
};

renderApp();
serviceWorker.unregister();
